<template>
<div>
  <b-navbar toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center container-p-x">

    <!-- Brand demo (see demo.css) -->
    <b-navbar-brand to="/" class="app-brand demo d-lg-none py-0 mr-4">
      <span class="app-brand-logo demo">
        <img class="w-100" src="/vendor/img/logo.png" alt="" srcset="" >
      </span>
      <!-- <span class="app-brand-text demo font-weight-normal ml-2"></span> -->
    </b-navbar-brand>

    <!-- Sidenav toggle (see demo.css) -->
    <b-navbar-nav class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto" v-if="sidenavToggle">
      <a class="nav-item nav-link px-0 mr-lg-4" href="javascript:void(0)" @click="toggleSidenav">
        <!-- <i class="ion ion-md-menu text-large align-middle" /> -->
      </a>
    </b-navbar-nav>

    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

    <b-collapse is-nav id="app-layout-navbar">
      <!-- Divider -->
      <hr class="d-lg-none w-100 my-2">
      <a href="javascript:void(0)" @click="toggleSidenav" class="text-muted align-middle ml-3" style="font-size: 14px"><i class="ion ion-md-menu text-large align-middle"></i></a>

      <b-navbar-nav class="align-items-lg-center ml-auto">
        <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">|</div>

        <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user">
          <template slot="button-content">
            <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
              <!-- <img :src="`${baseUrl}img/avatars/1.png`" alt class="d-block ui-w-30 rounded-circle"> -->
              <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{userInfo.name}}</span>
            </span>
          </template>

          <!-- <b-dd-item><i class="ion ion-ios-person text-lightest"></i> &nbsp; 个人中心</b-dd-item>
          <b-dd-item><i class="ion ion-ios-mail text-lightest"></i> &nbsp; 我的消息</b-dd-item>
          <b-dd-item><i class="ion ion-md-settings text-lightest"></i> &nbsp; 系统设置</b-dd-item> -->
          <b-dd-item @click="openModal"><i class="ion ion-md-key text-lightest"></i> &nbsp; 修改密码</b-dd-item>
          <b-dd-divider />
          <b-dd-item @click="logout"><i class="ion ion-ios-log-out text-danger"></i> &nbsp; 退出登录</b-dd-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  <b-modal ref="formModal" :hide-footer="true" :no-enforce-focus="true" :no-close-on-backdrop="true">
      <div slot="modal-title">修改密码</div>
      <b-form @submit.prevent="changePassword">
        <b-form-row>
          <b-form-group label="旧密码" class="col position-relative">
            <b-input :type="old_type"
              v-model.trim="old_password"
              :state="$v.old_password.$dirty? !$v.old_password.$error : null"
              aria-describedby="old_passwordFeedback" placeholder="请输入旧密码" />
              <span v-if="old_type==='password'" @click="old_type = 'text'" class="password-eye">
                <i class="far fa-eye"></i>
              </span>
              <span v-else @click="old_type = 'password'" class="password-eye">
                <i class="far fa-eye-slash"></i>
              </span>
            <b-form-invalid-feedback id="old_passwordFeedback">
              旧密码不能为空
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group label="新密码" class="col">
            <b-input :type="new_type"
              v-model.trim="new_password"
              :state="$v.new_password.$dirty ? !$v.new_password.$error : null"
              aria-describedby="new_passwordFeedback" placeholder="请输入新密码" />
              <span v-if="new_type==='password'" @click="new_type = 'text'" class="password-eye">
                <i class="far fa-eye"></i>
              </span>
              <span v-else @click="new_type = 'password'" class="password-eye">
                <i class="far fa-eye-slash"></i>
              </span>
            <b-form-invalid-feedback v-if="!$v.new_password.required">
              新密码不能为空
            </b-form-invalid-feedback >
            <b-form-invalid-feedback v-if="!$v.new_password.minLength">
              新密码不能少于6个字
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group label="重复新密码" class="col">
            <b-input :type="repeat_type"
              v-model.trim="repeatPassword"
              :state="$v.repeatPassword.$dirty ? !$v.repeatPassword.$error : null"
              aria-describedby="newpasswordFeedback" placeholder="请重复新密码" />
              <span v-if="repeat_type==='password'" @click="repeat_type = 'text'" class="password-eye">
                <i class="far fa-eye"></i>
              </span>
              <span v-else @click="repeat_type = 'password'" class="password-eye">
                <i class="far fa-eye-slash"></i>
              </span>
            <b-form-invalid-feedback v-if="!$v.repeatPassword.sameAsPassword">
              两次密码必须相同
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-row>
        <hr class="mx--4">
        <div class="mt-2 d-flex justify-content-end">
          <div>
            <b-btn variant="default" @click="closeModal">取消</b-btn>
            <b-btn type="submit" variant="primary">保存</b-btn>
          </div>
          </div>
      </b-form>
    </b-modal>

    <!-- 修改密码成功 -->
    <b-modal ref="successModal" :hide-footer="true" size="md" :no-enforce-focus="true" :no-close-on-backdrop="true">
      <div slot="modal-title">修改密码成功</div>
      <b-form-group label="用户名">
        <b-input v-model.trim="userInfo.account" disabled />
      </b-form-group>
      <b-form-group label="密码">
        <b-input v-model.trim="new_password" disabled />
      </b-form-group>
      <div class="mt-2 d-flex justify-content-end">
          <b-btn variant="default" @click="hideSuccessModal">关闭</b-btn>
      </div>
    </b-modal>

    <notifications group="notifications-default" :duration="2000" animation-name="v-fade-left" position="top right">
    </notifications>
</div>
</template>

<script>
import { removeUserInfo } from '@/utils/storage'
import { validationMixin } from 'vuelidate'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
export default {
  name: 'app-layout-navbar',
  data () {
    return {
      // name: getUserBizInfo().name,
      old_type: 'password',
      new_type: 'password',
      repeat_type: 'password',
      old_password: '',
      new_password: '',
      repeatPassword: '',
      userInfo: JSON.parse(localStorage.getItem('user_biz_info')).admin_info
    }
  },
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    old_password: {
      required
    },
    new_password: {
      required,
      minLength: minLength(6)
    },
    repeatPassword: {
      required,
      sameAsPassword: sameAs('new_password')
    }
  },
  methods: {
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    },
    logout () {
		let token = JSON.parse(localStorage.getItem('user_biz_info')).token
      let data = {
        token
      }
      this.$http.post(`/logout`,data).then(res => {
        removeUserInfo()
        setTimeout(() => {
          this.$router.push({
            path: '/login'
          })
        }, 10)
      })
    },
    openModal () {
      this.$v.$reset()
      this.$refs.formModal.show()
    },
    closeModal () {
      this.$refs.formModal.hide()
    },
    hideSuccessModal () {
      this.$refs.successModal.hide()
	  this.$router.push({path: '/login'})
    },
    changePassword () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let data = {
			account: this.userInfo.account,
          oldPassword: this.old_password,
          newPassword: this.new_password
        }
        this.$http.put(`/admins/${this.userInfo.id}/u_p`,data).then(res => {
          this.$refs.formModal.hide()
          if (res.code === 1) {
            this.$notify({
              group: 'notifications-default',
              type: 'bg-success text-white',
              title: '修改成功'
            })
            this.$refs.successModal.show()
			localStorage.clear()
          } else if (res.code === 40004) {
            this.$notify({
              group: 'notifications-default',
              type: 'bg-danger text-white',
              title: '旧密码输入错误'
            })
          } else {
            this.$notify({
              group: 'notifications-default',
              type: 'bg-danger text-white',
              title: res.msg
            })
          }
        })
      } else {
        this.$notify({
          group: 'notifications-default',
          type: 'bg-danger text-white',
          title: '请填写完整表单'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.password-eye{
  position: absolute;
  right: 0.5rem;
  top: 0.2rem;
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>
